import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CourseGroupInput,
  courseGroupSelector,
  setCourseGroup,
} from 'features/classCreation';
import Field from 'components/Field';

function TaSkills({ errors }) {
  const dispatch = useDispatch();
  const courseGroup = useSelector(courseGroupSelector);

  const handleCourseGroupChange = useCallback(
    (newCourseGroup) => {
      dispatch(setCourseGroup(newCourseGroup));
    },
    [dispatch]
  );

  return (
    <Field
      label="TA Skills"
      className="m-b-l"
      name="course_group"
      serverErrors={errors}
    >
      <CourseGroupInput
        value={courseGroup}
        onChange={handleCourseGroupChange}
      />
    </Field>
  );
}

export default TaSkills;
